<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :class="customStyle"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
</template>

<script>
export default {
  name: 'PlusRoundedIcon',
  props: {
    customStyle: {
      type: String,
      default: 'size-5',
    },
  },
}
</script>
